const config = {
	host: process.env.VUE_APP_API_URL, //接口域名
	imgRoot: '', //图片前缀
};
if (process.env.NODE_ENV === 'development') {
	//开发环境
} else if (process.env.NODE_ENV === 'production') {
	//生产环境
}
export default config